import { atom } from "recoil";

/**
 * Global fallback (Peniche / Nazaré) until a starred home spot, a Florida
 * return visit, or geolocation chooses somewhere else.
 */
export const DEFAULT_REGION_ID = "Praias Costa Oeste";

/** The currently active region ID. Maps to regions in Firestore. */
export const activeRegionAtom = atom<string>({
  key: "activeRegion",
  default: DEFAULT_REGION_ID,
});
